import { Component, Input,ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
declare var window: any;
declare var $: any;
declare var inputEmails: any;
@Component({
    selector: 'dialog-share-folder.component',
    templateUrl: './dialog-share-folder.component.html',
    styleUrls: ['./dialog-share-folder.component.scss'],
  })
export class DialogShareFolderComponent {
  @ViewChild("shareform") shareform: any;
  
  @Input() title: string = 'Share File(s)';
  @Input() body: string;
  @Input() size: string = 'sm1';

  sendtype: string = 'email';
  phoneNumber: string = '';
  inputPhone: any = null;
  phoneNumberError: boolean = false;

  data: any = {
    sendtype: 'email',
    txtPhone:'',
    txtEmail:'',
    txtDescription: '',
    txtDate: '',
    txtReqDate: '',
    txtPass: '',
    txtReqPass: '',
    chkDownload: false
  };
   submitted: boolean = false;
   isEmailEmpty: boolean = false;

  constructor(protected ref: NbDialogRef<DialogShareFolderComponent>) {
    setTimeout(() => {
      $("#txtEmail").email_multiple({data: []});
    }, 10);
  }

  onShare(formData: any, isValid: boolean): void {
    this.submitted = true;
    this.isEmailEmpty = false;
    if (!isValid) {
      return;
    }
    this.data.txtPass =  this.data.txtPass.replace(/\D/g,'');
    this.data.txtPhone =  this.data.txtPhone.replace(/\D/g,'');

    if(formData.txtPass == '' || formData.txtPass == null){
      formData.txtReqPass = false;
    }else{
       formData.txtReqPass = true;
    } 

    formData.txtDate = this.data.txtDate;
    if(formData.txtDate == '' || formData.txtDate == null){
      formData.txtReqDate = false;
      formData.txtDate = null;
    }else{
      formData.txtReqDate = true;
    }

    formData.chkDownload = !formData.chkDownload;

    if(this.data.sendtype=='email'){
       $("#inputEmail").val('');
        let emailArray = [];
        Array.from($('.all-mail .email-ids .email-ids-name')).forEach(element => {
          emailArray.push((element as HTMLElement).innerHTML);
        });

        if(emailArray.length == 0){
          this.isEmailEmpty = true;
          return;
        }

        formData.txtEmail = emailArray.join(',');
        formData.type = this.data.sendtype;
        this.ref.close(formData);
    }else if(this.data.sendtype=='phone'){
       formData.type = this.data.sendtype;
      const iti = window.intlTelInput.getInstance(this.inputPhone);
      let txtPhone = $('#txtPhone').val().replace(/\D/g,'');
      if(txtPhone.length < 9) {
        this.phoneNumberError = true;
        return;
      }else{
          let phoneData = {
              code: iti.getSelectedCountryData().iso2,
              number: txtPhone
          };
          formData.phone = phoneData;

          this.ref.close(formData);
      }
    }
    
  }
  
  dismiss() {
    this.ref.close();
  }

  onChange(event: any) {
    if (event == 'phone') {
      setTimeout(() => {
         this.inputPhone = document.querySelector("#txtPhone");
         window.intlTelInput(this.inputPhone , {
          initialCountry: "us",
          separateDialCode: true,
          geoIpLookup: (success, failure) => {
            fetch("https://ipapi.co/json")
              .then((res) => res.json())
              .then((data) => success(data.country_code))
              .catch(() => failure());
          }
        });
      }, 10);
    }else if (event == 'email') {
      setTimeout(() => {
        $("#txtEmail").email_multiple({data: []});
      }, 10);
    }
  }

  filterFn(date): any {
    return date > (new Date()).setDate((new Date()).getDate());
  }

  checkEmailEmpty() {
    return this.submitted && this.isEmailEmpty && $('.all-mail .email-ids .email-ids-name').length == 0;
  }

  phoneNumberOnly(event): boolean {
      this.phoneNumberError = false;
      return this.numberOnly(event);
  }

  numberOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
      }
      return true;
  }
}